<template>
  <div>
    <div class="project-list">
      <div class="project-item" :class="{'border-right': i !== list.length-1 && (i+1)%3 !==0,'border-0': i%2===0&&i===list.length-2 ||i===list.length-1 }" v-for="(v, i) in list" :key="i" @click="goArtcle(v)">
        <img class="bg-img" :src="v.imgUrl || '/a'" @error="imgError('/img/fileimg.png')">
        <div class="project-title txt-line-1 hidden-xs-only">{{v.title}}</div>
        <a class="shade-btn">
          <span class="ds-btn">查看详情</span>
        </a>
        <div class="project-title-xs txt-line-3">{{v.title}}</div>
      </div>
    </div>
    <div class="project-pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getArticleListByColId} from '@/api/project'
import {imgError} from '@/assets/utility'

export default {
  props: {
    colid: String
  },
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 30,
      total: 0
    }
  },
  mounted() {
    
  },
  methods: {
    loadData(pId) {
      getArticleListByColId(pId, this.currentPage, this.pageSize).then(res => {
        if (res) {
          //this.handleData(res.rows)
          this.list = res.rows
          this.total = res.total - 0
        }
      })
    },
    goArtcle(pData) {
      this.$router.push(`/article/${pData.id}`)
    },
    handleCurrentChange(e) {
      this.currentPage = e
      this.loadData(this.colid)
    },
    imgError(pUrl) {
      imgError(pUrl)
    },
    handleData (data) {
      if(localStorage.getItem('langType') === 'en') {
          data.map(value => {
          value.content = value.contentEn
          value.described = value.describedEn
          value.subTitle = value.subTitleEn
          value.title = value.titleEn
          return value
        })
      }
      return data
    }
  }
}
</script>

<style>

</style>